export const EMPTY_USERS = 'Users/EMPTY_USERS';
export const SET_USERS = 'Users/SET_USERS';
export const SET_SORTED_USERS = 'Users/SET_SORTED_USERS';

export const FETCH_USERS = 'Users/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'Users/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'Users/FETCH_USERS_FAILURE';

export const SEND_USERS_CSV_START = 'Users/SEND_USERS_CSV_START';
export const SEND_USERS_CSV_SUCCESS = 'Users/SEND_USERS_CSV_SUCCESS';
export const SEND_USERS_CSV_FAILURE = 'Users/SEND_USERS_CSV_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/constants.js